import {OrderItem} from "./order-item";

export class Order {
    public id:number
    public status:string
    public orderItems:OrderItem[]
    public total:number;
    public discount:number;
    public customer_id:number;
    public customer:string;
    public creation_date:Date;
    public last_update_date:Date;

    constructor() {
        this.id = null;
        this.status = 'pending';
        this.orderItems = [];
        this.total = 0;
        this.discount = 0;
        this.creation_date = new Date();
        this.last_update_date = new Date();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/order.ts